// extracted by mini-css-extract-plugin
export default {"container":"iP-z","topReviewHeading":"jP-z","criticalReview":"kP-z","favorableReview":"lP-z","vsSeparator":"mP-z"};